import AMAServiceClient from '../clients/AMAServiceClient';
import AQUAServiceClient from '../clients/AQUAServiceClient';
import selectors from '../../rootSelectors';
import { LANGUAGE } from '../../constants/language';
import { setUser } from '../user/userActions';
import USER_TYPE from '../../constants/userType';
import keycloak from '../keycloak/keycloak';
import { getStudentResults, resultsFetchReset } from '../api/resultStudentActions';
import { startRetriableGet, retriableGetComplete, retriableGetFailed } from '../api/apiCallActions';
import { APP_DATA_FETCH_RETRY } from '../api/apiRetryGetConstants';
import playlistsHaveOnlineItem from '../utils/playlistUtils';

export const LOAD_PLAYLIST = 'LOAD_PLAYLIST';
export const SET_PLAYLIST_ITEM_COMPLETED = 'SET_PLAYLIST_ITEM_COMPLETED';
export const SET_RAW_PLAYLISTS_BY_PERIOD = 'SET_RAW_PLAYLISTS_BY_PERIOD';
export const SET_DATA_IS_FETCHED = 'SET_DATA_IS_FETCHED';

export const loadPlaylist = playlists => ({
    type: LOAD_PLAYLIST,
    payload: { playlists },
});

export const setRawPlaylistsByPeriod = playlists => ({
    type: SET_RAW_PLAYLISTS_BY_PERIOD,
    payload: { playlists },
});

export const setDataIsFetched = () => ({
    type: SET_DATA_IS_FETCHED,
});

export const setPlaylistItemCompleted = (measureKey, language = LANGUAGE.ENG) => {
    return {
        type: SET_PLAYLIST_ITEM_COMPLETED,
        measureKey,
        language,
    };
};

export const setNextToyPlaylist = () => (dispatch, getStore) => {
    const state = getStore();
    const fromStore = selectors.getNextPlaylists(state);
    const playlists = fromStore === undefined ? [] : fromStore;
    dispatch(startRetriableGet(APP_DATA_FETCH_RETRY));
    dispatch(loadPlaylist(playlists));
    dispatch(resultsFetchReset());
    return dispatch(getStudentResults()).then(
        () => dispatch(retriableGetComplete(APP_DATA_FETCH_RETRY)),
        () => dispatch(retriableGetFailed(APP_DATA_FETCH_RETRY)),
    );
};

/**
 * Retrieves array of playlist objects, but currently array has one object.
 * If successful, sets playlist data to store.
 */
export const getPlaylist = retryActionName => {
    return (dispatch, getStore) => {
        const state = getStore();
        return dispatch(
            AMAServiceClient.getPlaylist(selectors.getUserId(state), retryActionName),
        ).then(async allPlaylists => {
            if (allPlaylists.length > 0 && playlistsHaveOnlineItem(allPlaylists)) {
                await dispatch(setRawPlaylistsByPeriod(allPlaylists));
                await dispatch(setNextToyPlaylist());
            } else {
                // we need to trigger result fetch (which will send no requests) in order to let app know that
                // result fetch was completed
                await dispatch(getStudentResults());
                await dispatch(setDataIsFetched());
            }
        });
    };
};

export const setARPlaylist = period => {
    return dispatch => {
        const studentPlaylist = {
            assessment_type: 'BM',
            create_time: Date.now(),
            modify_time: Date.now(),
            playlist_id: null,
            period,
        };

        return dispatch(AQUAServiceClient.getAQUAUserId()).then(response => {
            if (response) {
                return dispatch(AQUAServiceClient.getAQUAUserDataById(response.UserId)).then(
                    userData => {
                        if (userData) {
                            const userId =
                                userData.StudentEnrollmentUid !== null
                                    ? userData.StudentEnrollmentUid
                                    : '';
                            studentPlaylist.grade = userData.Grade;
                            studentPlaylist.inst_uid = userData.OrganizationId;
                            studentPlaylist.school_year = userData.SchoolYear;
                            studentPlaylist.student_uid = userData.UserExternalId;
                            studentPlaylist.playlist_items = [
                                {
                                    measure: 'TRO',
                                    modality: 'online',
                                    student_enrollment_id: userId,
                                    inst_uid: userData.OrganizationId,
                                },
                            ];

                            const userType = keycloak.tokenParsed.realm_access.roles.includes(
                                USER_TYPE.STUDENT,
                            )
                                ? USER_TYPE.STUDENT
                                : '';
                            dispatch(
                                setUser(
                                    userData.UserExternalId,
                                    keycloak.tokenParsed.name,
                                    userType,
                                ),
                            );
                            return dispatch(loadPlaylist([studentPlaylist]));
                        }
                        return Promise.reject(userData);
                    },
                );
            }
            return Promise.reject(response);
        });
    };
};
